/* eslint-disable import/first */

/* Rails UJS */
import Rails from '@rails/ujs';

Rails.start();

/* Bootstrap */
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
